<template>
  <section>
    <left-menu />

    <div id="mainContent" class="point-control">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">Gestão de ponto</h1>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 ">
          <!-- Box Filter -->
          <div class="col-xs-12 col-sm-12 col-md-12 offset-top-30 default-box filter-day">
            <!--Info -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div class="info-card-blue">
                <div class="nunito">1</div>
                <div class="nunito">DATA DOS PONTOS</div>
                <div class="nunito">Preencha a data que deseja visualizar os ponto</div>
              </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-12">
              <form name="form" class="form-filter" novalidate>
                <!-- Inputs -->
                <div class="col-xs-12 col-sm-12 col-md-12 padding-null">
                  <div class="col-xs-12 col-sm-6 col-md-3 content">
                      <p>Data Inicial</p>
                      <datepicker ref="programaticOpen1" v-model="initialDate" :language="ptBR" :format="customFormatter"/>
                      <svg width="24" height="24" viewBox="0 0 24 24"><path d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z" class="a"></path></svg>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3 content ">
                    <p>Pesquise por funcionário</p>
                    <autocomplete
                      id="myAutocomplete"
                      anchor="name"
                      label="writer"
                      placeholder="Nome do funcionário"
                      v-bind:url="urlSearchEmp"
                      v-model="userSelected"
                      :customHeaders="{Authorization: 'bearer ' + bearerAutoComplete, Contentsetting: this.contentSetting}"
                      :min="1"
                      :debounce="500"
                      :onAjaxProgress="callbackEvent"
                      :onAjaxLoaded="callbackEvent"
                      :on-select="getDataSelected">
                    </autocomplete>
                    <img v-if="isSearchWithUser" v-on:click="reloadEmployers()" src="../../../../assets/img/fail_send.png" class="img-responsive remove-user remove-user-icon2"/>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3 content ">
                    <p>Pesquise por Equipe</p>
                    <select v-model="selectedTeam">
                      <option value="">Todas</option>
                      <option v-for="team in listTeam" v-bind:value="team.id">
                        {{ team.name }}
                      </option>
                    </select>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3 content ">
                    <button v-on:click.prevent="searchPointControl()" class="certa btn-search-day" type="submit">Pesquisar</button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30">
            <div class="col-xs-12 col-sm-12 col-md-12 default-box box-list-day">
              <div class="infos">
                <h2 class="certa">Lista de pontos</h2>

                <p v-if="!loadingMoreItem && allPointDate.items.length" v-on:click="showCardInfo = !showCardInfo" title="Clique para visualizar as informações ou fechar" class="open-close-icon">
                  <i class="fa fa-question-circle" aria-hidden="true"></i>
                </p>
              </div>

              <!-- Legenda -->
              <div v-if="!loadingMoreItem && allPointDate.items.length" class="box-legend">
                <div v-if="showCardInfo" class="expandable padding-null"> <!--  uib-collapse="!showCardInfo" -->
                  <div class="row">
                    <div class="col-xs-12 col-sm-4 col-md-2">
                      <div class="col-xs-12 col-sm-12 col-md-12 legend padding-null">
                        <div><span class="pending certa">Sem registro</span></div>
                        <p class="nunito">Colaborador não bateu nenhum ponto até o momento no dia.</p>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-4 col-md-2">
                      <div class="col-xs-12 col-sm-12 col-md-12 legend padding-null">
                        <div><span class="working certa">Trabalhando</span></div>
                        <p class="nunito">Colaborador bateu ponto de entrada.</p>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-4 col-md-2">
                      <div class="col-xs-12 col-sm-12 col-md-12 legend padding-null">
                        <div><span class="interval certa">Intervalo/Saída</span></div>
                        <p class="nunito">Colaborador não está em horário de trabalho.</p>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-4 col-md-2">
                      <div class="col-xs-12 col-sm-12 col-md-12 legend padding-null">
                        <div><span class="done certa">Concluído</span></div>
                        <p class="nunito">Colaborador concluiu o dia batendo os pontos corretamente.</p>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-4 col-md-2">
                      <div class="col-xs-12 col-sm-12 col-md-12 legend padding-null">
                        <div><span class="incorrect certa">Ocorrência</span></div>
                        <p class="nunito">Colaborador bateu o número errado de pontos no dia.</p>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-4 col-md-2">
                      <div class="col-xs-12 col-sm-12 col-md-12 legend padding-null">
                        <div><span class="fault certa">Falta</span></div>
                        <p class="nunito">Colaborador não bateu nenhum ponto em um dia trabalhado.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <loading-table v-if="loadingTable" />

              <div v-if="allPointDate.items.length">
                <!-- Btn pdf, excel -->
                <div v-if="!loadingMoreItem && allPointDate.items.length" class="btn-pdf-excel">
                  <p class="nunito txt-help">Para gerar Excel ou PDF clique no botão abaixo.</p>
                  <button v-on:click="employerPoint({isPrint: true})" class="background-red" type="submit">
                    <div v-if="loadingPdf" class="loading-btn">
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                    <span v-else>PDF</span>
                  </button>
                  <button v-on:click="employerPoint({isExcel: true})" class="background-green" type="submit">
                    <div v-if="loadingExcel" class="loading-btn">
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                    <span v-else>EXCEL</span>
                  </button>
                </div>

                <div class="table-responsive table-clean">
                  <table class="table">
                    <thead>
                    <tr>
                      <th class="certa"> Data </th>
                      <th class="certa"> Funcionário </th>
                      <th class="certa"> Total trabalhado </th>
                      <th class="certa" v-if="showColumnPause"> Total pausa </th>
                      <th class="certa"> Pontos </th>
                      <th class="certa"> Status </th>
                      <th class="certa"> Visualizar </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="pu in allPointDate.items">
                      <td><p class="nunito day-info no-wrap">{{pu.date | formatDate}} <span>{{pu.date | strDay}}</span></p></td>
                      <td>
                        <a target="_blank" v-bind:href="'/perfil/1/' + pu.uid" class="link2">{{pu.userName}}</a>
                      </td>
                      <td>
                        <p>{{pu.totalHours}}</p>
                      </td>
                      <td v-if="showColumnPause">
                        <p>{{pu.totalInPause}}</p>
                      </td>
                      <td>
                        <p>{{pu.firstPointHour}}</p>
                      </td>
                      <td>
                        <p
                          v-bind:class="{
                            'status-default': pu.userPointDayStatus === 0,
                            'status-interval': pu.userPointDayStatus === 1,
                            'status-work': pu.userPointDayStatus === 2,
                            'status-done' :pu.userPointDayStatus === 3,
                            'status-incorrect': pu.userPointDayStatus === 4,
                            'status-fault': pu.userPointDayStatus === 5}">
                          {{pu.status}}
                        </p>
                      </td>
                      <td>
                        <a v-bind:href="'/detalhes-do-dia/1/' + pu.id" target="_blank" class="link nunito" title="Visualizar dia" >Visualizar dia</a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <!-- Infinite Scroll -->
                <mugen-scroll :handler="getMoreItems" :should-handle="!loadingMoreItem">
                  <!-- Loading -->
                  <div v-if="loadingMoreItem" class="loader-page-content">
                    <div class="spinner">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                </mugen-scroll>
              </div>

              <div v-if="!loading && !allPointDate.items.length && !loadingMoreItem && !loadingTable && !failRequest" class="col-xs-12 col-sm-12 col-md-12 box-empty">
                <p class="nunito">Nenhum registro encontrado.</p>
              </div>

              <div v-if="!loading && !allPointDate.items.length && !loadingMoreItem && !loadingTable && failRequest" class="col-xs-12 col-sm-12 col-md-12 box-empty">
                <p class="nunito">Tivemos um problema com a conexão. Tente novamente atualizando a página.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>


<!-- Script from page -->
<script>
  import leftMenu from '../../components/leftMenu.vue';
  import vueFooter from "../../components/footer";
  import loadingTable from "../../components/loadingTable";

  import swal from 'sweetalert';
  import moment from 'moment'
  import { SEARCH_EMPLY, GET_USER_POINT_FILTER, GET_USER_TEAM } from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";

  import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
  import datepicker from 'vuejs-datepicker';
  import Autocomplete from 'vue2-autocomplete-js'
  import MugenScroll from 'vue-mugen-scroll'

  export default {
    name: 'pointControl',
    components: {
      leftMenu,
      loadingTable,
      vueFooter,
      Autocomplete,
      datepicker,
      MugenScroll
    },
    data() {
      return {
        listTeam: [],
        selectedTeam: '',
        loadingTable: false,
        loadingExcel: false,
        loadingPdf: false,
        pageNumber: 1,
        itemsPerPage: 25,
        loadingMoreItem: false,
        haveMoreEmployer: true,
        isSearchWithUser: false,
        urlSearchEmp: SEARCH_EMPLY,
        bearerAutoComplete: JSON.parse(window.localStorage.getItem('authUser')).userToken,
        contentSetting: JSON.parse(window.localStorage.getItem('authUser')).userContentSetting,
        showCardInfo: false,
        userSelected: "",
        ptBR: ptBR,
        selectedDate: "",
        initialDate: new Date(),
        failRequest: false,
        loading: false,
        showColumnPause: JSON.parse(window.localStorage.getItem('userInfo')).company.isUsingPause,
        allPointDate: {
          items: []
        },
        pgNumber: 1,
        pageQtd: 50,
      }
    },
    methods: {
      getMoreItems() {
        if (this.allPointDate.items.length && this.haveMoreEmployer) {
          this.loadingMoreItem = true;
          this.pgNumber++;
          this.employerPoint();
        }
      },
      callbackEvent(value) {
        console.log(value);
      },
      customFormatter(date) {
        return moment(date).format('DD/MM/YYYY');
      },
      openCalendar1: function () {
        this.$refs.programaticOpen1.showCalendar();
      },
      getDataSelected(obj){
        if (obj.name && obj.id) {
          this.userSelected = obj;
          this.isSearchWithUser = true;
        }
      },
      reloadEmployers() {
        $('#myAutocomplete').val('');
        this.userSelected = '';
        this.isSearchWithUser = false;
      },
      getMyTeam() {
        REQUEST_SERVICE.get(GET_USER_TEAM + JSON.parse(window.localStorage.getItem('userInfo')).companyId).then((response) => {
          UTIL_SERVICE.console("RESULT GET_USER_TEAM:", response.data);

          this.listTeam = response.data;
        }).catch(reason => {
        });
      },
      employerPoint(value) {
        if (!value) {
          this.loadingTable = true;
          this.loadingMoreItem = true;
        }

        let url = GET_USER_POINT_FILTER + "?pageNumber=" + this.pgNumber;
        url += "&pageQtd=" + this.pageQtd;
        url += "&date=" + moment(this.initialDate).format("YYYY-MM-DD");

        if (this.userSelected.id) {
          url += "&userIds=" + this.userSelected.id;
        }

        if (this.selectedTeam) {
          url += "&team=" + this.selectedTeam;
        }

        if (value) {
          if (value.isPrint) {
            url += "&isPrint=true";
            this.loadingPdf = true;
          } else if (value.isExcel) {
            url += "&isExcel=true";
            this.loadingExcel = true;
          }
        }

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT GET_USER_POINT_FILTER:", response.data);
          if (value) {
            if (value.isPrint) {
              this.loadingTable = false;
              this.loadingPdf = false;

              let el = document.createElement('div');
              let link = "PDF gerado, clique no <a title='PDF Gerado' href='changeUrl' target='_blank'>link</a> para abrir.";
              link = link.replace("changeUrl", response.data);
              el.innerHTML = link;

              swal({
                title: "Sucesso!",
                icon: "success",
                content: el,
                button: {
                  text: "Fechar",
                  closeModal: true,
                }
              });

            } else {
              try {
                this.loadingExcel = false;
                let blob = new Blob([response.data], {type: "application/octet-stream"});
                let url = window.URL.createObjectURL(blob);

                let linkElement = document.createElement('a');
                linkElement.setAttribute('href', url);
                linkElement.setAttribute("download", 'gestao-de-ponto.csv');

                let clickEvent = new MouseEvent("click", {
                  "view": window,
                  "bubbles": true,
                  "cancelable": false
                });
                linkElement.dispatchEvent(clickEvent);

                this.loadingTable = false;
                this.loadingMoreItem = false;
              } catch (ex) {
                this.loadingExcel = false;
                this.loadingPdf = false;
                this.loadingTable = false;
                this.loadingMoreItem = false;
              }
            }
          } else {

            if (response.data.items.length) {
              response.data.items.map((value, index) => {
                this.allPointDate.items.push(value);
              });

              if (response.data.items.length < 25)
                this.haveMoreEmployer = false;
            } else {
              this.haveMoreEmployer = false;
            }

            this.failRequest = false;
            this.loadingTable = false;
            this.loadingMoreItem = false;
          }
        }).catch(reason => {
          this.failRequest = true;
          this.loadingMoreItem = false;
          this.loadingTable = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      searchPointControl() {
        this.allPointDate.items = [];
        this.pgNumber = 1;
        this.employerPoint();
      }
    },
    beforeMount() {
      if (JSON.parse(window.localStorage.getItem('showCardInfoWeb')) !== null ) {
        this.showCardInfo = JSON.parse(window.localStorage.getItem('showCardInfoWeb')).show;
      } else {
        this.showCardInfo = true;
        window.localStorage.setItem('showCardInfoWeb', JSON.stringify({show: false}));
      }

      this.employerPoint();
      this.getMyTeam();
    }
  }
</script>

<style lang="scss">
  .box-point-control {
    .input-with-date {
      width: 100%;

      input {
        width: 100%;
      }
    }

    // Auto complete
    .remove-user {
      position: absolute;
      top: 35px;
      right: 24px;
      cursor: pointer;
    }

    .select-team {
      label {
        display: block;
      }

      select {
        width: 100%;
        height: 41px;
        padding: 6px 12px;
        background-color: #fff;
        border: 1px solid #c2cad8;
        border-radius: 4px;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
      }
    }

    .btn-pdf-excel {
      margin-top: 20px;
      height: 80px;

      p {
        display: block;
        text-align: end;
        font-size: 12px;
        margin-bottom: 5px;
      }

      .pdf {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        float: right;
        border: none;
        height: 36px;
        width: 140px;
        background: #e74a4e;
        color: #fff;
        font-weight: 600;

        &:hover,&:active,&:focus {
          background-color: #c13437;
        }
      }

      .excel {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        float: right;
        border: none;
        height: 36px;
        width: 140px;
        background: #00a651;
        color: #fff;
        font-weight: 600;

        &:hover,&:active,&:focus {
          background-color: #027f3f;
        }
      }
    }

    .autocomplete-input {
      width: 100%;
      height: 36px;
      padding: 6px 12px;
      background-color: #fff;
      border: 1px solid #c2cad8;
      border-radius: 4px;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;

      @media screen and (max-width: 414px){
        width: 100%;
      }
    }

    .transition, .autocomplete, .showAll-transition, .autocomplete ul, .autocomplete ul li a{
      transition:all 0.3s ease-out;
      -moz-transition:all 0.3s ease-out;
      -webkit-transition:all 0.3s ease-out;
      -o-transition:all 0.3s ease-out;
    }

    .autocomplete ul{
      z-index: 1;
      font-family: "Montserrat", sans-serif;
      position: absolute;
      list-style: none;
      background: #d8d8d8;
      padding: 10px 0;
      display: inline-block;
      min-width: 15%;
      margin: 10px 0 0;
    }

    .autocomplete ul:before{
      content: "";
      display: block;
      position: absolute;
      height: 0;
      width: 0;
      border: 10px solid transparent;
      border-bottom: 10px solid #d8d8d8;
      left: 46%;
      top: -20px
    }

    .autocomplete ul li a{
      text-decoration: none;
      display: block;
      background: #d8d8d8;
      color: #2b2b2b;
      padding: 10px 5px 5px 10px;

      b {
        font-weight: 600;
        letter-spacing: 1px;
      }
    }

    .autocomplete ul li a:hover, .autocomplete ul li.focus-list a{
      color: #ffffff;
      background: #0f77ae;
    }

    .autocomplete ul li a span, /*backwards compat*/
    .autocomplete ul li a .autocomplete-anchor-label{
      display: block;
      margin-top: 3px;
      color: grey;
      font-size: 13px;
    }

    .autocomplete ul li a:hover .autocomplete-anchor-label,
    .autocomplete ul li.focus-list a span, /*backwards compat*/
    .autocomplete ul li a:hover .autocomplete-anchor-label,
    .autocomplete ul li.focus-list a span{ /*backwards compat*/
      color: white;
    }

    .result-list-table {
      background: #fff;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
      padding: 40px 40px 20px 40px;
      -webkit-border-radius: 4px !important;
      -moz-border-radius: 4px !important;
      border-radius: 4px !important;
      margin-bottom: 80px;

      .content-title {
        font-size: 15px;
        font-weight: 600;
        color: #7b7878;
        border-bottom: 1px solid #7b7878;
        float: right;
        margin-bottom: 30px;
        margin-top: 0;
      }

      blockquote {
        padding: 0 20px;
        margin: 0 0 30px;
        border-left: 5px solid #7b7878;

        p {
          font-size: 15px;
          font-weight: 600;
          color: #7b7878;
          margin: 0 0 6px;
        }
      }

      .success-box-table {
        color: #FFFFFF;
        border: 0;
        padding: 5px 14px;
        border-radius: 4px !important;
        background-color: #00a651;
        font-weight: 600;
        position: relative;
        top: 7px;
      }

      .incorrect-box-table {
        color: #FFFFFF;
        border: 0;
        padding: 5px 18px;
        font-weight: 600;
        border-radius: 4px !important;
        background-color: #e74a4e;
        position: relative;
        top: 7px;
      }
    }

    // Box Legend
    .box-legend {
      background: #fff;

      .open-close-icon {
        i {
          float: right;
          font-size: 20px;
          top: -15px;
          cursor: pointer;
          position: relative;
        }
      }

      .open-close {
        font-size: 16px;
        margin-left: 15px;
        margin-bottom: 25px;
        color: #201e1e;
        border-bottom: 1px solid #7b7878;
        cursor: pointer;
        padding-bottom: 15px;


        &:after {
          font-family: FontAwesome;
          content: "\F054";
          float: right;
          margin-right: 15px;
        }
      }

      .active {
        &:after {
          -webkit-transition: all .35s;
          -o-transition: all .35s;
          transition: all .35s;
          transform: rotate(+90deg);
        }
      }

      button {
        background: transparent;
        border: none;
        position: absolute;
        right: 26px;
        top: 6px;
        font-size: 24px;
        font-weight: bold;
        cursor: pointer;
      }

      .legend {
        background-color: #f9f9f9;
        -webkit-border-radius: 4px !important;
        -moz-border-radius: 4px !important;
        border-radius: 4px !important;
        min-height: 130px;
        max-height: 130px;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
        margin-bottom: 30px;
        border-top: 1px solid #dad6d6;

        .pending {
          background: #a5afbd;
        }

        .interval {
          background: #0F77AE;
        }

        .done {
          background: #00a651;
        }

        .fault {
          background: #e74a4e;
        }

        .incorrect {
          background :#c29d0b;
        }

        .working {
          background-color: #3598dc;
        }

        span {
          position: relative;
          top: 15px;
          left: -5px;
          padding: 4px 10px;
          color: #fff;
          font-size: 13px;
          font-weight: normal;
          text-transform: uppercase;
          max-width: 100%;
        }

        p {
          color: #201e1e;
          margin-top: 30px;
          font-size: 12px;
          text-align: left;
          padding: 0 10px;
          border-bottom: none;
        }
      }
    }
  }

  .vdp-datepicker__calendar {
    left: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/pointControl/pointControl.vue